/** 自定義元件 共同邏輯 */
export default {
  data() {
    return {
      dataValue: {}
    }
  },
  watch: {
    value: function(val) {
      this.dataValue = val
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    /** 索引值 用於更新數據 */
    index: Number,
    /** 包含數據源 */
    item: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    /** 如果有值以傳入值為主 如果無值 已預設值為主 */
    this.dataValue = this.value
  },

  methods: {
    // 輸入的值
    valueChange(val) {
      this.$emit('value-change', {
        index: this.index,
        value: val
      })
    }
  }

}
